module.exports = __webpack_public_path__ + "img/logo1.9d38c726.png";